module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "dashContent"
  }, [_c('div', {
    staticClass: "panel-heading componentHeader"
  }, [_c('div', {
    staticClass: "pull-left"
  }, [_c('h2', [_vm._v(_vm._s(_vm.getTranslation('lbl_panel_headline_tickets')))])]), _vm._v(" "), _c('div', {
    staticClass: "pull-right"
  }, [_c('div', {
    staticStyle: {
      "display": "inline-block"
    }
  }, [_c('strong', [_vm._v(_vm._s(_vm.getTranslation('lbl_ticket_filter')) + ":")]), _vm._v(" "), _c('div', {
    directives: [{
      name: "on-clickaway",
      rawName: "v-on-clickaway",
      value: (_vm.dropClose),
      expression: "dropClose"
    }],
    staticClass: "dropdown",
    class: {
      open: _vm.isOpened
    }
  }, [_c('button', {
    staticClass: "dropdown-toggle form-control",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.dropToggle($event)
      }
    }
  }, [_vm._v("\n                        " + _vm._s(_vm.getTranslation('lbl_ticket_filter_' + _vm.filterKey)) + "\n                        "), _c('span', {
    staticClass: "caret"
  })]), _vm._v(" "), _c('ul', {
    staticClass: "dropdown-menu dropdown-menu-right",
    on: {
      "click": _vm.dropToggle
    }
  }, [_c('li', [_c('a', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.toFilter('all');
      }
    }
  }, [_vm._v("\n                            " + _vm._s(_vm.getTranslation('lbl_ticket_filter_all')) + "\n                        ")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.toFilter('accepted');
      }
    }
  }, [_vm._v("\n                            " + _vm._s(_vm.getTranslation('lbl_ticket_filter_accepted')) + "\n                        ")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.toFilter('pending');
      }
    }
  }, [_vm._v("\n                            " + _vm._s(_vm.getTranslation('lbl_ticket_filter_pending')) + "\n                        ")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.toFilter('closed');
      }
    }
  }, [_vm._v("\n                            " + _vm._s(_vm.getTranslation('lbl_ticket_filter_closed')) + "\n                        ")])])])])])])]), _vm._v(" "), _c('table', {
    staticClass: "table table-striped table-condensed table-bordered"
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v(_vm._s(_vm.getTranslation('lbl_ticket_create')))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.getTranslation('lbl_ticket_state')))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.getTranslation('lbl_ticket_caller')))]), _vm._v(" "), _c('th', {
    staticClass: "action"
  }, [_vm._v(_vm._s(_vm.getTranslation('lbl_grid_col_action')))])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.filtered), function(ticket, indx) {
    return _c('tr', [_c('td', [_c('span', [_vm._v(_vm._s(_vm.formatDisplayDate(ticket.created)))])]), _vm._v(" "), _c('td', [_c('span', [_vm._v(_vm._s(ticket.stateLabel))])]), _vm._v(" "), _c('td', [_c('span', [_vm._v(_vm._s(ticket.caller))])]), _vm._v(" "), _c('td', {
      staticStyle: {
        "white-space": "nowrap"
      }
    }, [_c('button', {
      staticClass: "btn btn-default",
      attrs: {
        "title": _vm.getTranslation(_vm.audioTooltip(indx))
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.audioPlay(indx)
        }
      }
    }, [_c('span', {
      staticClass: "fa",
      class: _vm.audioButtonClass(indx),
      attrs: {
        "aria-hidden": "true"
      }
    })]), _vm._v(" "), _c('button', {
      staticClass: "btn btn-primary",
      attrs: {
        "title": _vm.getTranslation('lbl_history')
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.showHistory(ticket._id)
        }
      }
    }, [_c('span', {
      staticClass: "fa fa-history",
      attrs: {
        "aria-hidden": "true"
      }
    })]), _vm._v(" "), _c('audio', {
      ref: "audio",
      refInFor: true,
      attrs: {
        "id": 'audio' + indx,
        "src": _vm.recordingUrl + ticket._id
      },
      on: {
        "ended": function($event) {
          _vm.audioStop(indx)
        }
      }
    }), _vm._v(" "), (_vm.ticketActive(ticket.state)) ? _c('button', {
      staticClass: "btn btn-warning",
      on: {
        "click": function($event) {
          _vm.closeTheTicket(ticket._id)
        }
      }
    }, [_c('span', {
      staticClass: "fa fa-window-close-o",
      attrs: {
        "aria-hidden": "true",
        "title": _vm.getTranslation('lbl_close_ticket')
      }
    })]) : _vm._e()])])
  }))]), _vm._v(" "), _c('banet-modal-info', {
    attrs: {
      "show": _vm.showModalInfo,
      "showFooter": true,
      "body": _vm.ticketHistory,
      "title": _vm.callStatusHeader
    },
    on: {
      "infoClose": _vm.closeModalInfo
    }
  }), _vm._v(" "), _c('banet-modal-confirm', {
    attrs: {
      "show": _vm.showConfirm,
      "showFooter": true,
      "title": _vm.getTranslation('modal_confirm_title'),
      "body": _vm.getTranslation('label_confirm_ticket_close')
    },
    on: {
      "confirmNo": function($event) {
        _vm.confirm(false)
      },
      "confirmYes": function($event) {
        _vm.confirm(true)
      }
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-69b35302!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App/protected/components/tickets/Tickets.vue
// module id = 686
// module chunks = 0